/* eslint-disable max-len */
/* eslint-disable complexity */

export default {
    name: 'PostalAddressDetail',

    /**
     * @override
     */
    props: {
        data: {
            type: Object,
            required: true
        }
    }
};
